import React, { Suspense } from 'react'
const MonthlyReportEmailLazy = React.lazy(() => import('../pages/MonthlyReportEmail.page'))

export const monthlyReportEmail = [
  {
    path: 'monthly-report-email',

    element: (
      <Suspense fallback={<div></div>}>
        <MonthlyReportEmailLazy />
      </Suspense>
    ),
  },
]
